import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DocumentDto} from "../../../../auto-generated-server-dtos/claim/files/document-dto";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DownloadDocumentService {
  constructor(private httpClient: HttpClient) { }

  downloadDocument(documentId: number) : Observable<Blob> {
    return this.httpClient.get(`${environment.apiServer}/Claim/Files/DownloadDocument`, {
      responseType: 'blob',
      params: {documentId: documentId}
    });
  }
}
